import localforage from 'localforage';

localforage.config({ name: 'ST' });

const setIdbItem = async (key, value) => {
  // sets indexedDb item and returns promise
  const item = await localforage.setItem(key, value);
  return item;
};

const getIdbItem = async (key) => {
  // gets indexedDb item and returns promise
  const item = await localforage.getItem(key);
  return item;
};

const setLocalStorageItem = (key, value) => {
  // sets localStorage item
  localStorage.setItem(key, value);
};

const getLocalStorageItem = (key) => {
  // gets localStorage item, returns string
  const item = localStorage.getItem(key);
  return item;
};

const kvpConstants = {
  separator: '=',
  delimiter: '&'
};

const parseKeyValue = (data) => {
  const keyValueMap = new Map();
  if (data) {
    const pairs = data.split(kvpConstants.delimiter);
    if (pairs) {
      pairs.forEach((pair) => {
        const p = pair.split(kvpConstants.separator);
        keyValueMap.set(p[0], p[1]);
      });
    }
  }
  return keyValueMap;
};

const addUpdateKeyValue = (data, key, value) => {
  const map = parseKeyValue(data);
  // updated the value
  map.set(key, value);
  const kvp = [];
  map.forEach((v, k) => {
    const pair = `${k}${kvpConstants.separator}${v}`;
    kvp.push(pair);
  });
  return kvp.join(kvpConstants.delimiter);
};

const removeLocalStorageItem = (key) => {
  // sets localStorage item
  localStorage.removeItem(key);
};

const getAndRemoveLocalStorageItem = (key) => {
  // removes the localStorage item after reading and returning it.
  const item = localStorage.getItem(key);
  localStorage.removeItem(key);
  return item;
};

const StorageConstants = {
  Keys: {
    sitemap: 'rcoreSitemapHash',
    theme: 'SumtTheme'
  },
  SitemapHash: 'sitemapHash',
  DashboardHash: 'dashboardHash',
  RcoreDashboardHash: 'rcoreDashboardHash'
};

export {
  setIdbItem,
  getIdbItem,
  setLocalStorageItem,
  getLocalStorageItem,
  parseKeyValue,
  addUpdateKeyValue,
  removeLocalStorageItem,
  getAndRemoveLocalStorageItem,
  StorageConstants
};
